import React, { useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import SettingsPanel from "../../../components/settings/SettingsPanel";
import CompanyProfile from "../../../components/settings/CompanyProfile";
import { ClientType, SettingsDetailsType } from "../../../types/genericType";
import { getSettingsDetails } from "../../../services/settingsService";
import { getClientById } from "../../../services/clientService";

const Settings = () => {
  const [value, setValue] = useState("1");
  const [settingsData, setSettingsData] = useState<SettingsDetailsType>({
    LoanMessage: "",
    InvestmentMessage: "",
    Quote: "",
    NextCheckNumber: 0,
    StatementEmailSubject: "",
    StatementEmailBody: "",
    MonthEndDescription: "",
    ManagementFees: "",
    ManagementRate: "",
    VariableInvestmentRate: "",
    TotalRate: "",
    CompanyEmail: "",
    ManagementFirm: "",
  });
  const [companyData, setCompanyData] = useState<ClientType>({
    id: 0,
    name: "",
    firstName: "",
    lastName: "",
    taxNumber: "",
    officePhone: "",
    type: "",
    homePhone: "",
    mobile: "",
    fax: "",
    address: "",
    apartment: "",
    city: "",
    state: "",
    zip: "",
    country: "",
  });
  const dataFetchedRef = useRef(false);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const getSettingsData = () => {
    getSettingsDetails()
      .then((res: SettingsDetailsType) => {
        setSettingsData(res);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  const getCompanyProfileDetails = async () => {
    getClientById("1")
      .then((data: ClientType) => {
        if (data) {
          setCompanyData(data);
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  useEffect(() => {
    if (dataFetchedRef.current) return;
    dataFetchedRef.current = true;
    getSettingsData();
    getCompanyProfileDetails();
  }, []);

  useEffect(() => {
    getSettingsData();
    getCompanyProfileDetails();
  }, [value]);

  return (
    <Box sx={{ width: "532px", typography: "body1", backgroundColor: "white" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Settings" value="1" />
            <Tab label="Company Profile" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1">
          <SettingsPanel settingsData={settingsData} />
        </TabPanel>
        <TabPanel value="2">
          <CompanyProfile
            settingsData={settingsData}
            companyData={companyData}
          />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default Settings;
